// Lib Imports
import React from 'react';
import { Box, Button } from 'grommet';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

// CORE Imports
import FormField from 'granite-admin/core/components/FormField';
import OtpInput from 'granite-admin/core/components/OtpInput';
// Application Imports
// import ACCOUNT_VERIFICATION_EVENTS from '../constants'

const VerificationForm = ({
  eventEmitter,
  verifyAccountClicked,
  type,
  userProfile
}) => {
  const validationSchema = Yup.object().shape({
    token: Yup.string().required('Verification token is required')
  });
  const onSubmit = async (values, {
    setSubmitting,
    setErrors
  }) => {
    setErrors({});
    setSubmitting(true);
    try {
      let obj = {
        [type]: userProfile[type],
        token: values.token
      };
      // console.log(obj)
      await verifyAccountClicked(eventEmitter, obj);
    } catch (e) {
      if (e.errors) setErrors(e.errors);
    }
    setSubmitting(false);
  };
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      token: ''
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit
  }, ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    handleSubmit,
    isSubmitting
  }) => /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(FormField, {
    name: "token",
    label: "Verification Token",
    error: touched.token && errors.token,
    noBorder: true
  }, /*#__PURE__*/React.createElement(OtpInput, {
    name: "token",
    onChange: otp => setFieldValue('token', otp),
    onBlur: handleBlur,
    value: values.token,
    numInputs: 6
  })), /*#__PURE__*/React.createElement(Box, {
    fill: "horizontal",
    direction: "column",
    elevation: "none",
    justify: "between",
    pad: "none"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    alignSelf: "start",
    margin: {
      vertical: 'small'
    },
    label: isSubmitting ? 'Veriyfing ...' : 'Verify',
    disabled: isSubmitting,
    primary: true,
    color: "secondary"
  }))));
};
VerificationForm.propTypes = {
  eventEmitter: PropTypes.func,
  verifyAccountClicked: PropTypes.func,
  type: PropTypes.string,
  userProfile: PropTypes.object
};
export default VerificationForm;